import { i18nKeys } from 'translationTypes'
import * as DA from '../../../typeModules/events'
import t from './strings'

export const COLOR_PINK_BGC = '#fbf1f0'
export const COLOR_LEGAL_LINK = '#3344dd'

export const LANDING = {
  FORM_CONTAINER: {
    HEIGHT: '400px',
    MIN_WIDTH: '480px',
    MOBILE: {
      MIN_WIDTH: '240px',
    },
  },
}

export const SIGNUP_FORM = {
  LEGAL_TEXT: {
    LETTER_SPACING: '-0.01ch',
  },
}

export const HEADER_SECTION = {
  ROOT: {
    MIN_HEIGHT: '768px',
  },
  TERMS_BUTTON: {
    FONT_WEIGHT: 600,
  },
  TEXT_CONTAINER: {
    PADDING_BOTTOM: '400px',
  },
  TITLE_TEXT: {
    FONT_WEIGHT: 600,
    LINE_HEIGHT: 1,
    MAX_WIDTH: '42rem',
    MOBILE_FONT_SIZE: '28px'
  },
  SUBTITLE_TEXT: {
    FONT_SIZE: '28px',
    MAX_WIDTH: '32rem',
  },
}

export const LANDING_CONTENT = {
  MAX_WIDTH: '2560px',
}

export const SPACING = {
  LARGE_128: '128px',
}

export const SIZES = {
  LARGE_48: '48px',
  MEDIUM_36: '36px',
}

export const FAQList = [
  {
    title: t.faq1Title(),
    description: i18nKeys.dasherApplyPage__faq1__description,
  },
  {
    title: t.faq2Title(),
    description: i18nKeys.dasherApplyPage__faq2__description,
  },
  {
    title: t.faq3Title(),
    description: i18nKeys.dasherApplyPage__faq3__description,
  },
  {
    title: t.faq4Title(),
    description: i18nKeys.dasherApplyPage__faq4__description,
  },
  {
    title: t.faq5Title(),
    description: i18nKeys.dasherApplyPage__faq5__description,
  },
  {
    title: t.faq6Title(),
    description: i18nKeys.dasherApplyPage__faq6__description,
  },
  {
    title: t.faq7Title(),
    description: i18nKeys.dasherApplyPage__faq7__description,
  },
  {
    title: t.faq8Title(),
    description: i18nKeys.dasherApplyPage__faq8__description,
  },
  {
    title: t.faq9Title(),
    description: i18nKeys.dasherApplyPage__faq9__description,
  },
  {
    title: t.faq10Title(),
    description: i18nKeys.dasherApplyPage__faq10__description,
  },
]

export const WhatIsDoorDashText = {
  content: [
    {
      text: [t.whatIsDoorDashLine1(), t.whatIsDoorDashLine2()],
    },
  ],
}

export const SignUpDetailsText = {
  content: [
    {
      subtitle: t.signUpDetailsSubtitle1(),
      text: [
        t.signUpDetailsSubtitle1Line1(),
        t.signUpDetailsSubtitle1Line2(),
        t.signUpDetailsSubtitle1Line3(),
        t.signUpDetailsSubtitle1Line4(),
        t.signUpDetailsSubtitle1Line5(),
      ],
      trackingId: DA.SignUpDetailsTitles.Requirements,
    },
    {
      subtitle: t.signUpDetailsSubtitle2(),
      text: [
        t.signUpDetailsSubtitle2Line1(),
        t.signUpDetailsSubtitle2Line2(),
        t.signUpDetailsSubtitle2Line3(),
        t.signUpDetailsSubtitle2Line4(),
      ],
      trackingId: DA.SignUpDetailsTitles.HowToSignUp,
    },
  ],
}

export const SignUpDetailsTextJP = {
  content: [
    {
      subtitle: t.signUpDetailsSubtitle1(),
      text: [
        t.signUpDetailsSubtitle1Line1(),
        t.signUpDetailsSubtitle1Line2(),
        t.signUpDetailsSubtitle1Line3(),
        t.signUpDetailsSubtitle1Line4ForJp(),
      ],
      trackingId: DA.SignUpDetailsTitles.Requirements,
    },
    {
      subtitle: t.signUpDetailsSubtitle2(),
      text: [
        t.signUpDetailsSubtitle2Line1(),
        t.signUpDetailsSubtitle2Line2(),
        t.signUpDetailsSubtitle2Line3(),
        t.signUpDetailsSubtitle2Line4(),
        t.signUpDetailsSubtitle2Line5(),
        t.signUpDetailsSubtitle2Line6(),
      ],
      trackingId: DA.SignUpDetailsTitles.HowToSignUp,
    },
  ],
}

export const SCROLL_THROTTLE_MS = 200
export const HEADER_HEIGHT_PX = 60